import {
  faChevronDown,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

const Consequences = ({ consequences, hideConsequences }) => {
  const [index, setIndex] = useState(0);
  const [openDetailIndex, setOpenDetailIndex] = useState(null);

  const nextConsequence = () => {
    if (index + 1 === consequences.length) {
      hideConsequences();
    } else {
      setIndex(index + 1);
      setOpenDetailIndex(null); // referme le détail quand on change
    }
  };

  useEffect(() => {
    if (consequences.length === 0) {
      hideConsequences();
    }
  }, [JSON.stringify(consequences)]);

  const toggleDetail = (i) => {
    setOpenDetailIndex(openDetailIndex === i ? null : i);
  };

  return (
    <div className="consequence-section">
      <div className="consequences">
        <div className="consequence-warning-container">
          <div className="consequence-warning">
            Illustrations fictives
          </div>
        </div>

        {consequences.map((consequence, i) => (
          <div
            key={consequence._id}
            className={
              index === i ? "consequence visible" : "consequence hidden"
            }
          >
            {/* Média ou contenu texte */}
            {consequence.type ? (
              consequence.type === "picture" ? (
                <img
                  className="consequence-image"
                  src={consequence.media_url}
                  alt="consequence"
                />
              ) : (
                <video controls className="video-display">
                  <source src={consequence.media_url} type="video/mp4" />
                  Sorry, your browser doesn't support videos.
                </video>
              )
            ) : (
              <div className="consequence-container">
                <h3>{consequence.title}</h3>
                <p>{consequence.description}</p>
              </div>
            )}

            {/* 🔍 EN SAVOIR PLUS */}
            {consequence.detail && (
              <div className="consequence-detail-wrapper">
                <div
                  className="consequence-detail-toggle"
                  onClick={() => toggleDetail(i)}
                >
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    className="info-icon"
                  />
                  <span>En savoir plus sur cette conséquence</span>
                </div>

                {openDetailIndex === i && (
                  <div className="consequence-detail-content">
                    {consequence.detail}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
        
        <FontAwesomeIcon
        className="next"
        icon={faChevronDown}
        onClick={nextConsequence}
      />
      </div>


    </div>
  );
};

export default Consequences;
